<template>
    <div>
      <div
        v-tooltip="{content: copied ? 'Copied' : 'Copy',placement:'bottom',trigger:'hover focus',autoHide: false,hideOnTargetClick: false}"
        :class="copied ? 'active' : ''"
        @click="copyLink"
        @mouseleave="delayCancelCopy"
        class="copy-icon"
      />
      <input id="copy-input" type="text" style="position:fixed;top:-9999px;" value="TExttttttttt">
    </div>
</template>

<script>
export default {
  name: 'ShareCopyVue',
  props: {
    content: {
      default: null,
      type: String
    }
  },
  data: function() {
    return {
      copied: false
    }
  },
  methods: {
    copyLink() {
      // Effect
      this.copied = true
      //  Copy
      const tempInput = document.createElement('input')
      tempInput.style = 'position: fixed; left: -1000px; top: -1000px'
      tempInput.value = this.content
      document.body.appendChild(tempInput)
      tempInput.select()
      document.execCommand('copy')
      document.body.removeChild(tempInput)
    },
    delayCancelCopy() {
      const vm = this
      setTimeout(() => {
        vm.copied = false
      }, 300)
    }
  }
}
</script>

<style scoped>

</style>
